const { getElement } = window.BAO.Utils

export class ProductCardForm extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleVariantChange = this.handleVariantChange.bind(this)
    this.listeners.add(
      this.els.select.element,
      'change',
      this.handleVariantChange,
    )
  }

  handleVariantChange () {
    const variantId = this.els.select.element.value
    let available =
      this.els.select.element.selectedOptions[0]?.dataset.available
    available = available === 'true'

    this.form.els.variantId.element.value = variantId

    this.form.els.text.element.textContent = available
      ? window.theme.strings.addToCart
      : window.theme.strings.soldOut

    this.form.els.submit.element.toggleAttribute('disabled', !available)

    const formPanel = this.form.querySelector(
      '[data-product-add-to-cart-panel]',
    )

    formPanel.setAttribute('aria-hidden', !available)

    const backInStockPanel = this.form.querySelector(
      '[data-product-back-in-stock-panel]',
    )
    const backInStockForm = this.form.querySelector(
      '[data-product-back-in-stock-form]',
    )

    backInStockPanel.setAttribute('aria-hidden', available)

    backInStockForm.toggleAttribute('disabled', available)
    backInStockForm.setAttribute('data-variant-id', variantId)
  }

  get form () {
    return getElement('product-form', { context: this })
  }
}

if (!customElements.get('product-card-form')) {
  customElements.define('product-card-form', ProductCardForm)
}
